(function () {
    'use strict';

    angular.module("imApp").factory("factoringsService", [function () {
        let service = {};

        return service;
    }]);
})();
